<template>
  <v-select
    label="Client Type"
    :outlined="outlined"
    :items="items"
    item-text="name"
    item-value="id"
    v-model="selectedClientType"
    @change="onChange"
    :clearable="clearable"
  ></v-select>
</template>

<script>
import { removeGQLTypename } from "../../../helpers";
import { ALL_CLIENT_TYPES_SEARCH_QUERY } from "../../../constants/graphql";
export default {
  name: "client-type-list-select",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      selectedClientType: this.value ? this.value : null,
    };
  },
  computed: {
    items() {
      return this.clientTypes && this.clientTypes.edges
        ? this.clientTypes.edges
            .map(removeGQLTypename)
            .filter((item) =>
              this.value
                ? !item.notInUse || item.id == this.value
                : !item.notInUse
            )
        : [];
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.selectedClientType = newVal;
      }
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.selectedClientType);
    },
  },

  apollo: {
    clientTypes: {
      query: ALL_CLIENT_TYPES_SEARCH_QUERY,
      variables() {
        return {
          filter: {
            not_in_use_eq: false,
          },
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ClientTypeListSelect.vue